import React, { useState } from "react";
import {
  Alert,
  Button,
  Modal,
  NewTable,
  PageHeader,
  PageTitle,
  TableAdv,
} from "../../../../../../components";
import { mapTableRows } from "../../../../../../utils";
import { employeePaymentDetailsrowData } from "../../../../../../assets/data/candidatesData";
import common from "../../../../../../utils/common";
import { useDispatch } from "react-redux";
import { empOtherPayementsTimeSheet } from "../../../../../../redux/slices/employee/employeeSlice";
import { exactUTCDate } from "../../../../../../utils/dateFormator";
import { formatCurrency } from "../../../../../../utils/stringUtils";
import { last } from "pdf-lib";

const UnapaidtimesheetdetailsModel = ({
  open,
  onClose,
  unPaidTimeSheet = [],
  selectedRows,
  setSelectedRows,
  empOtherPayemntsSelectTimeSheets,
}) => {
  const dispatch = useDispatch();
  const { convertLocalFormatMMDDYYYY } = common;
  const [showValidationAlert, setShowValidationAlert] = useState(false);
  const handleProceedClick = () => {
    if (selectedRows.length === 0) {
      setShowValidationAlert(true);
      return;
    }

    handleCloseModal();
  };

  const handleCloseModal = () => {
    console.log("-----");
    dispatch(empOtherPayementsTimeSheet([])); // Dispatch action
    setSelectedRows([]);
    onClose();
  };

  const EmployepaymentdetailsColumns = [
    {
      key: "JobTitle",
      label: "Job Title",
      width:"text-nowrap!",
      render: (row) => {
        return <div>{row?.placementId?.jobInfo?.jobTitle}</div>;
      },
    },
    {
      key: "Client",
      label: "Client",
      width:"text-nowrap!",
      render: (row) => {
        return <div>{row?.clientId?.businessName}</div>;
      },
    },
    {
      key: "PayCycle",
      label: "Pay Cycle",
      width:"text-nowrap!",
      render: (row) => {
        const fromDate = exactUTCDate(row?.period?.from);
        const toDate = exactUTCDate(row?.period?.to);
        return <div>{`${fromDate} - ${toDate}`}</div>;
      },
    },
    // {
    //   key: "Classification",
    //   label: "Classification",
    //   render: (row) => {
    //     const payClassification =
    //       row?.placementId?.timesheetDetails?.payClassification || [];
    //     const lastClassification =
    //       payClassification[payClassification.length - 1];
    //     return <div>{lastClassification?.field || "N/A"}</div>;
    //   },
    // },
    {
      key: "invoiceNums",
      label: "Invoice Numbers",
      width:"text-nowrap!",
      render: (row) => {
        return <div>{row?.invoiceId?.flatMap((id) => id.invoiceNum).join(", ")}</div>;
      },
    },
    {
      key: "TotalHours",
      label: "Total Hours",
      width:"text-nowrap!",
      render: (row) => {
        const totalHours = row?.dailyEntries
          ?.reduce((acc, curr) => acc + curr.st, 0)
          .toFixed(2);
        return <div>{totalHours}</div>;
      },
    },
    {
      key: "billRate",
      label: "Bill Rate",
      width:"text-nowrap!",
      render: (row) => {
        const payments = row?.placementId?.payments || [];
        const lastPayment = payments[payments.length - 1];
        return <div>{lastPayment?.billRate?.rate ?? "N/A"}</div>;
      },
    },
    {
      key: "PayRate",
      label: "Pay Rate",
      width:"text-nowrap!",
      render: (row) => {
        const payments = row?.placementId?.payments || [];
        const lastPayment = payments[payments.length - 1];
        return <div>{lastPayment?.payRate?.payRatePerHour ?? "N/A"}</div>;
      },
    },
    {
      key: "percentage",
      label: "Percentage",
      width:"text-nowrap!",
      render: (row) => {
        const payments = row?.placementId?.payments || [];
        const lastPayment = payments[payments.length - 1];
        const billRate = lastPayment?.billRate?.rate ?? 0;
        const payRate = lastPayment?.payRate?.payRatePerHour ?? 0;
        const percentage = ((payRate / billRate) * 100).toFixed(2);
        return <div>{percentage}%</div>;
      },
    },
    {
      key: "paid",
      label: "Paid",
      width:"text-nowrap!",
      render: (row) => {
        return (
          <div>
            {row?.amounts?.paid ? row?.amounts?.paid.toFixed(2) : 0}
          </div>
        );
      },
    },
    {
      key: "balance",
      label: "Balance",
      width:"text-nowrap!",
      render: (row) => {
        const payments = row?.placementId?.payments || [];
        const lastPayment = payments[payments.length - 1];
        const payRatePerHour = lastPayment?.payRate?.payRatePerHour ?? 0;
        const totalHours =
          row?.dailyEntries?.reduce((acc, curr) => acc + (curr?.st || 0), 0) ??
          0;
        const total = (payRatePerHour * totalHours).toFixed(2);
        const totalAfterPaid = Number(total) - (Number(row?.amounts?.paid || 0));
        return (
          <div>
            {totalAfterPaid ? totalAfterPaid.toFixed(2) : 0}
          </div>
        );
      },
    },
  ];
  const mappedRows = mapTableRows(
    unPaidTimeSheet,
    EmployepaymentdetailsColumns,
  );

  const handleSubmitTimeSheet = () => {
    const selectData = unPaidTimeSheet.filter(
      (data) => selectedRows.includes(String(data._id)), // Convert data._id to string if needed
    );
    if (selectData.length > 0) {
      // Map through each record to update totalAmount
      const updatedData = selectData.map((record) => {
        console.log({ record });
        const payments = record?.placementId?.payments || [];
        const lastPayments = payments[payments.length - 1];
        const payRatePerHour = lastPayments?.payRate?.payRatePerHour || 0;
        const totalHours =
          record?.dailyEntries?.reduce(
            (acc, curr) => acc + (curr?.st || 0),
            0,
          ) ?? 0;
        const totalActual = (payRatePerHour * totalHours).toFixed(2);
        const totalAfterPaid = totalActual - (record?.amounts?.paid || 0);
        console.log({totalAfterPaid})

        //old logic commented on the 09/01/2025 as per vikrants logic to calculate with latest payrate
        // const amounts = record?.amounts || {}; // Safe destructuring
        // record.totalTimeAmount = (amounts?.total || 0) - (amounts?.paid || 0); // Calculate remaining amount
        record.totalTimeAmount = totalAfterPaid;

        return record; // Return the updated record
      });
      dispatch(empOtherPayementsTimeSheet(updatedData));
      // onClose();
      onClose();
    } else {
      dispatch(empOtherPayementsTimeSheet([]));
    }
  };

  return (
    <Modal
      isOpen={open}
      onClose={handleCloseModal}
      title="UNPAID TIMESHEET DETAILS"
      width="max-w-6xl"
    >
      {/* <div>
        <PageHeader
          Section={
            <div className="flex">
              <PageTitle title="Timesheets - opted to Pay as Other payment" tag="h6" />
            </div>
          }
        />
        <NewTable
          columns={EmployepaymentdetailsColumns}
          rows={[]}
          hideToolBar
          showCheckbox={false}
        />    // has per viranth disable-15-07-25
      </div> */}

      <div className="mt-4 flex flex-1 flex-col overflow-hidden">
        {/* <div className="border-b w-full">
          <PageHeader
            Section={
              <div className="flex">
                <PageTitle title="OTHER UNPAID TIMESHEETS" tag="h6" />
              </div>
            }
          />
        </div> */}

        <TableAdv
          tableId={`Employee_Payments_Otherpayments_unpaidtimesheetdetailsmodel`}
          columns={EmployepaymentdetailsColumns}
          rows={mappedRows}
          hideToolBar
          showCheckbox
            onSelectionChange={(rows) =>{
              // handleSubmitTimeSheet(rows)
              console.log({rows});
              setSelectedRows(rows);}
          }
          //bug fixed on 09/1/2025
          // defaultSelectedRows={
          //   selectedRows.length > 0
          //     ? selectedRows
          //     : empOtherPayemntsSelectTimeSheets.map((data) => data?._id)
          // }
          defaultSelectedRows={selectedRows}
          disableRowSelection={(row) => row?.isInvoiceNotPaid}
        />
      </div>

      <div className="flex gap-3 justify-end mt-3">
        <Button title="Cancel" variant="outlined" onClick={handleCloseModal} />
        <Button title="Submit" onClick={() => handleSubmitTimeSheet()} />
      </div>
      {/* <Alert
        isOpen={showValidationAlert}
        onClose={() => setShowValidationAlert(false)}
        title="Alert"
        description="At least select one Timesheet to submit"
        buttonsCenter
        acceptButton={{
          show: true,
          title: "OK",
          onClick: () => setShowValidationAlert(false),
        }}
      /> */}
    </Modal>
  );
};

export default UnapaidtimesheetdetailsModel;
